import {ColTypeDef} from "ag-grid-enterprise";
import {
  dateFilterParams,
  dateTimeFilterParams, numberFilterParams, setFilterParams,
  textFilterParams
} from "@/app/ag-grid/ag-grid-filters.ts";
import {formatDate, formatDateTime} from "@/util/date-formatting.ts";

export const columnTypes: Record<string, ColTypeDef> = {
  dateColumn: {
    filter: 'agDateColumnFilter',
    filterParams: dateFilterParams,
    valueFormatter: (p) => formatDate(p.value),
    maxWidth: 250,
  },
  dateTimeColumn: {
    filter: 'agDateColumnFilter',
    filterParams: dateTimeFilterParams,
    valueFormatter: (p) => formatDateTime(p.value),
    maxWidth: 250,
  },
  textColumn: {
    filter: 'agTextColumnFilter',
    filterParams: textFilterParams,
  },
  emailColumn: {
    filter: 'agTextColumnFilter',
    filterParams: textFilterParams,
    minWidth: 200,
  },
  numberColumn: {
    filter: 'agNumberColumnFilter',
    filterParams: numberFilterParams,
  },
  booleanColumn: {
    filter: 'agSetColumnFilter',
    filterParams: {
      ...setFilterParams,
      values: ['true', 'false'],
    },
    valueFormatter: (p) => (p.value ? 'Yes' : 'No'),
  },
  statusColumn: {
    filter: 'agSetColumnFilter',
    filterParams: setFilterParams,
    maxWidth: 150,
  },
  actionColumn: {
    filter: false,
    sortable: false,
    resizable: false,
    suppressHeaderMenuButton: true,
    suppressSizeToFit: true,
    pinned: 'right',
    cellStyle: { display: 'flex', alignItems: 'center', justifyContent: 'center' },
    minWidth: 80,
  },
}
